import { render, staticRenderFns } from "./Cellbox.vue?vue&type=template&id=2e9dc0a0&scoped=true&"
import script from "./Cellbox.vue?vue&type=script&lang=js&"
export * from "./Cellbox.vue?vue&type=script&lang=js&"
import style0 from "./Cellbox.vue?vue&type=style&index=0&id=2e9dc0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9dc0a0",
  null
  
)

export default component.exports